import script from "./KeepShoppingOrCart.vue?vue&type=script&setup=true&lang=js"
export * from "./KeepShoppingOrCart.vue?vue&type=script&setup=true&lang=js"

import "./KeepShoppingOrCart.vue?vue&type=style&index=0&id=48799d3e&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48799d3e"]])

export default __exports__